import React, { useEffect, useReducer } from 'react'
import { AppRouter } from './routers/AppRouter';
import { AuthContext } from './auth/AuthContext';
import { authReducer } from './auth/authReducer';

const init = () => {
    return JSON.parse(localStorage.getItem('user')) || { logged: false };
}

export const HeroesApp = () => {

    const [user, dispatch] = useReducer(authReducer, {}, init);

    // cuando ocurra un cambio en user guarda en el localStorage
    useEffect(() => {
        localStorage.setItem('user', JSON.stringify(user));
    }, [user])

    return (

        <AuthContext.Provider value={{user, dispatch}}>
            <AppRouter />
        </AuthContext.Provider>

    )
}
